import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { UltimoEscaneoComponent  } from "./ultimoescaneo";

export interface Props {
    /**Id de la carga ya sea de ruta o de EAD, no importa ya que no se utiliza para hacer el query, solo se utiliza para compararlo contra el id del ultimo escaneo */
    idCargaDescarga: number;
    /**Resumen de la carga/descarga */
    resumen: models.ResumenCargaDescarga;
    /**Ultoma lectura */
    ultimoEscaneo: models.UltimaLecturaFolioFisico | null;
}


class ResumenComp extends React.PureComponent<{ value: models.ResumenCargaDescarga }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <kea.Json value={{
                    "Guias": x.CantidadGuias,
                    "Pendientes": x.CantidadServiciosIncompletos,
                    "Paquetes": x.CantidadPaquetes,
                    "Sobres": x.CantidadSobres,
                }} />
            </div>
        )
    }
}

class ResumenCargaDescargaNoRx extends React.PureComponent<Props> {
    render() {
        const { resumen, ultimoEscaneo, idCargaDescarga } = this.props;

        return (
            <div>
                {kea.autogrid(6, [
                    <ResumenComp value={resumen} />,
                    <div>
                        <label>Ultimo servicio incluído</label>
                        <br />
                        <UltimoEscaneoComponent value={ultimoEscaneo} idCargaDescarga={idCargaDescarga} />
                    </div>
                ])}

            </div>);
    }
}

export const ResumenCargaDescarga = componentToRx(ResumenCargaDescargaNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/resumen.tsx